"use strict";
exports.__esModule = true;
function formatAccountSpecifics(account) {
    var nearResources = account.nearResources;
    if (!nearResources) {
        throw new Error("near account expected");
    }
    var str = " ";
    str += account.balance ? "\n    Full Balance: ".concat(account.balance) : "";
    str += nearResources.stakedBalance
        ? "\n    Staked Balance: ".concat(nearResources.stakedBalance)
        : "";
    str += nearResources.pendingBalance
        ? "\n    Pending Balance: ".concat(nearResources.pendingBalance)
        : "";
    str += nearResources.availableBalance
        ? "\n    Withdrawable Balance: ".concat(nearResources.availableBalance)
        : "";
    str += nearResources.storageUsageBalance
        ? "\n    Storage Usage Balance: ".concat(nearResources.storageUsageBalance)
        : "";
    if (nearResources.stakingPositions.length) {
        str += "\n    Staking Positions:\n";
        str += nearResources.stakingPositions
            .map(function (_a) {
            var validatorId = _a.validatorId, staked = _a.staked, pending = _a.pending, available = _a.available, rewards = _a.rewards;
            return "        Validator ID: ".concat(validatorId, " | Staked: ").concat(staked, " | Pending Release: ").concat(pending, " | Available: ").concat(available, " | Rewards: ").concat(rewards);
        })
            .join("\n");
    }
    return str;
}
exports["default"] = {
    formatAccountSpecifics: formatAccountSpecifics
};
//# sourceMappingURL=account.js.map